/* eslint-disable */
import Query from '../../components/Report';

const query = ({ offset = 0, entity }) =>
    new Query('discover-page-entity-top-authors', { offset, entity: entity?.replace(/'/g, "\\'") });

export default query;
